import React, { useEffect, useMemo, useState } from 'react';
import { Box, useMediaQuery, Modal } from '@mui/material';
import { observer } from 'mobx-react';
import cn from 'classnames';

import { useLocale } from 'src/providers/LocaleProvider';
import useStores from 'src/hooks/useStores';
import useChangeTheme from 'src/hooks/useChangeTheme';
import { Spinner } from 'src/components/spinner';
import ReturnToPrevious from 'src/pages/lobby/components/GamePreview/components/returnToFriends';

import { useStyles } from "./styles";
import DesktopUserSettings from "./desktopUserSettings";
import MobileUserSettings from "./mobileUserSettings";
import { ModalProvider } from "./hooks/useModalControls";
import UserSettings from "./components/Settings/UserSettings";
import SoundSettings from "./components/Settings/SoundSettings";
import ApperanceSettings from "./components/Settings/apperance/ApperanceSettings";
import { EUserSettigs } from "./type/type";

// Maybe we should move this component into src/components folder?
const UserSettingsContainer = () => {
    const { authStore } = useStores();
    const isOpenUserSettings = authStore.isOpenUserSettings;
    const styles = useStyles();
    const isTablet = useMediaQuery("(max-width: 1024px)");
    const appearanceTheme = useChangeTheme();
    const changeLanguage = authStore.getLanguage();
    const {
        userSettings: { sound, profileSettings, apperance, returnAction },
    } = useLocale();

    //useEffect(() => {
    //    setCurrentScreen(EUserSettigs.SOUND);
    //}, [changeLanguage]);

    const [currentScreen, setCurrentScreen] = useState<EUserSettigs>(
        EUserSettigs.SOUND
    );

    const onTabChange = (
        event: React.SyntheticEvent,
        newValue: EUserSettigs
    ) => {
        setCurrentScreen(newValue);
    };

    const tabSettingsContentList = useMemo(() => {
        return [
            {
                label: sound("Sound"),
                value: EUserSettigs.SOUND,
                component: <SoundSettings />,
            },
            {
                label: profileSettings("Profile Settings"),
                value: EUserSettigs.USER,
                component: <UserSettings />,
            },
            //{
            //    label: apperance("Appearance"),
            //    value: EUserSettigs.APPEARANCE,
            //    component: <ApperanceSettings />,
            //},
        ];
    }, [changeLanguage]);

    if (!isOpenUserSettings || !tabSettingsContentList) return null;

    return (
        <ModalProvider>
            <Modal
                open={isOpenUserSettings}
                onClose={() =>
                    authStore.toggleUserSettingsPage(!isOpenUserSettings)
                }
                className={cn(styles.modalSettingsMain, appearanceTheme)}
            >
                <Box
                    component='div'
                    className={cn(styles.modalSettingsWrapper, appearanceTheme)}
                >
                    <>
                        {isTablet ? (
                            <MobileUserSettings
                                value={currentScreen}
                                tabSettingsContentList={tabSettingsContentList}
                                onChange={onTabChange}
                                appearanceTheme={appearanceTheme}
                            />
                        ) : (
                            <DesktopUserSettings
                                value={currentScreen}
                                tabSettingsContentList={tabSettingsContentList}
                                onChange={onTabChange}
                                appearanceTheme={appearanceTheme}
                            />
                        )}
                    </>
                    <Box
                        component='div'
                        className={cn(
                            styles.returnToPreviousWrapper,
                            appearanceTheme
                        )}
                    >
                        <ReturnToPrevious
                            title={() => returnAction("Return")}
                            onClick={() =>
                                authStore.toggleUserSettingsPage(
                                    !isOpenUserSettings
                                )
                            }
                        />
                    </Box>
                </Box>
            </Modal>
        </ModalProvider>
    );
};

export default observer(UserSettingsContainer);
